module.exports = __webpack_public_path__ + "img/panelView_2_2.2ddb277f.png";